import tmhRequest from '@/config/tmhRequest'

export default {
  searchCustomerNursingLog: function (data) {
    return tmhRequest({
      url: '/customer/customernursinglog/searchcustomernursinglog',
      method: 'post',
      params: data,
    })
  },

  searchListCustomerNursingLog: function (data) {
    return tmhRequest({
      url: '/customer/tmh/customernursinglog/searchcustomernursinglog',
      method: 'post',
      params: data,
    })
  },

  searchCustomerNursingLogCount: function (data) {
    return tmhRequest({
      url: '/customer/tmh/customernursinglog/searchcustomernursinglogcount',
      method: 'post',
      params: data,
    })
  },

  searchCustomerNursingLogByPage: function (data) {
    return tmhRequest({
      url: '/customer/tmh/customernursinglog/searchcustomernursinglogbypage',
      method: 'post',
      params: data,
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/tmh/customer/customernursinglog.js